import { useEffect, useState } from "react";
import API from "../api";

function Inventory() {
  const [data, setData] = useState([]);
  const [stockInputs, setStockInputs] = useState({});
  const [loadingId, setLoadingId] = useState(null);

  const totalSheets = data.length;
  const totalStock = data.reduce((sum, item) => sum + Number(item.stock_sheets || 0), 0);
  const lowStockCount = data.filter(item => Number(item.stock_sheets) < 5).length;

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = () => {
    API.get("inventory/get-inventory/")
      .then(res => setData(res.data));
  };

  const handleInputChange = (sheetId, value) => {
    setStockInputs({
      ...stockInputs,
      [sheetId]: value
    });
  };

  const handleAddStock = async (sheetId) => {
    const quantity = stockInputs[sheetId];

    if (!quantity || quantity <= 0) return;

    try {
      setLoadingId(sheetId);

      await API.post("inventory/add-stock/", {
        sheet_id: sheetId,
        quantity: quantity
      });

      setStockInputs({
        ...stockInputs,
        [sheetId]: ""
      });

      fetchInventory();

    } catch (err) {
      alert("Error updating stock");
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div className="container-fluid px-0">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
        <h2 className="h4 mb-0">Inventory Management</h2>
        <button className="btn btn-sm btn-outline-secondary" onClick={fetchInventory}>
          Refresh
        </button>
      </div>

      <div className="card shadow-sm border-0">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-sm table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th className="px-3 py-2">Name</th>
                <th className="px-3 py-2 text-center" style={{ width: "160px" }}>Thickness (mm)</th>
                <th className="px-3 py-2 text-center" style={{ width: "120px" }}>Stock</th>
                <th className="px-3 py-2" style={{ width: "260px" }}>Add Stock</th>
              </tr>
            </thead>

            <tbody>
              {data.map(sheet => (
                <tr key={sheet.id}>
                  <td className="px-3 py-2 fw-medium">{sheet.name}</td>
                  <td className="px-3 py-2 text-center">{sheet.thickness_mm}</td>

                  <td className="px-3 py-2 text-center">
                    <span className={`badge fs-6 ${
                      sheet.stock_sheets < 5
                        ? "bg-danger"
                        : sheet.stock_sheets < 10
                        ? "bg-warning text-dark"
                        : "bg-success"
                    }`}>
                      {sheet.stock_sheets}
                    </span>
                  </td>

                  <td className="px-3 py-2">
                    <div className="d-flex gap-2">
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Qty"
                        value={stockInputs[sheet.id] || ""}
                        onChange={(e) =>
                          handleInputChange(sheet.id, e.target.value)
                        }
                      />

                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleAddStock(sheet.id)}
                        disabled={loadingId === sheet.id}
                      >
                        {loadingId === sheet.id ? "..." : "Add"}
                      </button>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Inventory;
